module.exports = __webpack_public_path__ + "static/media/island_sunrise.7f81faf4.gif";